export default __webpack_public_path__ + "static/media/angers13.6d46e59b.jpg";